module.exports = __webpack_public_path__ + "static/media/digi.5b7d9067.png";